import apolloClient from 'ecommerce/utils/apolloClient';
import NewPaginatedBoxActivities from 'ecommerce/assets/graphql/queries/newPaginatedBoxActivities.graphql';
import PaginatedBoxActivities from 'ecommerce/assets/graphql/queries/PaginatedBoxActivities.graphql';
import formatDate from 'ecommerce/filters/date/date.filter.js';

/**
 * @param box_slug {string} required
 * @param page_config {object} contains page_number and per_page
 * @param filters {object} contains province_id, order_by, search_term, at_home and category_id
 * @param time_range {object} contains date(required) and time_range_slug
 * @return data from paginated_box_activities query
 * @example
 * ('box-blend',{1,12},{},{'2023/02/20',''})
 */
const getPaginatedBoxActivities = async (
  box_slug,
  page_config,
  filters,
  time_range,
) => {
  let { per_page, page_number } = page_config;
  let { province_id, order_by, search_term, at_home, category_id } = filters;
  let { date, time_range_slug } = time_range;
  let dateFlag = false;
  let formattedDate = null;

  let selectedQuery = '';

  if (date) {
    dateFlag = true;
    formattedDate = formatDate(date, 'YYYY-MM-DD');
  }

  if (dateFlag) {
    selectedQuery = NewPaginatedBoxActivities;
  } else {
    selectedQuery = PaginatedBoxActivities;
  }

  const getVariables = () => {
    return selectedQuery === NewPaginatedBoxActivities
      ? {
          box_slug: box_slug,
          province_id: province_id,
          page_number: page_number,
          order_by: order_by,
          search_term: search_term,
          at_home: at_home,
          per_page: per_page,
          date: formattedDate,
          time_range_slug: time_range_slug,
          date_flag: dateFlag,
          category_id
        }
      : {
          box_slug: box_slug,
          provinceId: province_id,
          page_number: page_number,
          order_by: order_by,
          search_term: search_term,
          at_home: at_home,
          per_page: per_page,
          category_id
        };
  };

  try {
    const { data } = await apolloClient.query({
      query: selectedQuery,
      variables: getVariables(),
    });

    return selectedQuery === NewPaginatedBoxActivities
      ? {
          response: data.available_box_activities.paginated_available,
          others: data.available_box_activities.not_available,
        }
      : { response: data.paginated_box_activities, others: [] };
  } catch (e) {
    throw new Error(`${selectedQuery}`, e);
  }
};

export { getPaginatedBoxActivities };
